<div>
  <app-bringoz-countdown *ngIf="countToStart"
                         [ngClass]="selectedClass"
                         [to]="countToDate || from"
                         [keepCountWhenNegative]="keepCountWhenNegative"
                         [stopCount]="stopCount"
                         [negativeUntilFrom]="true"
                         (currentTimeChangedEvent)="onTimeChanged()">

  </app-bringoz-countdown>

  <app-bringoz-countdown *ngIf="!countToStart"
                         [ngClass]="selectedClass"
                         [from]="statusUpdatedAt"
                         [to]="countToDate || from"
                         [keepCountWhenNegative]="keepCountWhenNegative"
                         [stopCount]="stopCount"
                         [negativeUntilFrom]="true">
  </app-bringoz-countdown>

</div>



